import { T } from 'src/shared/helpers';
import { ComposerOptionActionsType } from './composerAttributesModels';

export type ComposerUnsupportedActionType = 'SHOW_HOTSPOT' | 'HIDE_HOTSPOT';
export type ComposerActionIcon =
    'visibility' | 'visibilityOff' | 'object' | 'part' | 'colour' | 'camera' | 'design' | 'pivot' | 'reset' | 'setting' | 'print' | 'hotspot';

export interface ComposerActionDefinition {
    key: string;
    type: ComposerOptionActionsType | ComposerUnsupportedActionType;
    name: string;
    description: string;
    valueLabel: string;
    icon: ComposerActionIcon;
    disabled?: boolean;
}

export const getComposerActionCatalog = (): ComposerActionDefinition[] => [
    {
        key: 'show',
        type: ComposerOptionActionsType.SHOW_OBJECTS,
        name: T._('Show parts', 'Admin'),
        description: T._('Bring objects into view', 'Admin'),
        valueLabel: '',
        icon: 'visibility'
    },
    {
        key: 'hide',
        type: ComposerOptionActionsType.HIDE_OBJECTS,
        name: T._('Hide parts', 'Admin'),
        description: T._('Take objects out of view', 'Admin'),
        valueLabel: '',
        icon: 'visibilityOff'
    },
    {
        key: 'material',
        type: ComposerOptionActionsType.SET_OBJECT_MATERIAL,
        name: T._('Change the material', 'Admin'),
        description: T._('Swap the material of whole objects', 'Admin'),
        valueLabel: T._('Material', 'Admin'),
        icon: 'object'
    },
    {
        key: 'submaterial',
        type: ComposerOptionActionsType.SET_SUB_OBJECT_MATERIAL,
        name: T._('Change the material of a part', 'Admin'),
        description: T._('Swap it on one sub-object, not the whole thing', 'Admin'),
        valueLabel: T._('Material', 'Admin'),
        icon: 'part'
    },
    {
        key: 'matcolor',
        type: ComposerOptionActionsType.SET_MATERIAL_COLOR,
        name: T._('Recolor a material', 'Admin'),
        description: T._('Same material, different color', 'Admin'),
        valueLabel: T._('Color', 'Admin'),
        icon: 'colour'
    },
    {
        key: 'camera',
        type: ComposerOptionActionsType.MOVE_CAMERA,
        name: T._('Move the camera', 'Admin'),
        description: T._('Frame the product from a saved camera', 'Admin'),
        valueLabel: T._('Camera', 'Admin'),
        icon: 'camera'
    },
    {
        key: 'design',
        type: ComposerOptionActionsType.SET_DESIGN_MATERIAL,
        name: T._('Change the printed design', 'Admin'),
        description: T._('The material the Designer area prints on', 'Admin'),
        valueLabel: T._('Design material', 'Admin'),
        icon: 'design'
    },
    {
        key: 'pivot',
        type: ComposerOptionActionsType.SET_CAMERA_PIVOT,
        name: T._('Set the camera pivot', 'Admin'),
        description: T._('The point the camera turns around', 'Admin'),
        valueLabel: T._('Pivot', 'Admin'),
        icon: 'pivot'
    },
    {
        key: 'pivotreset',
        type: ComposerOptionActionsType.RESET_CAMERA_PIVOT,
        name: T._('Reset the camera pivot', 'Admin'),
        description: T._('Put the turning point back at the center', 'Admin'),
        valueLabel: '',
        icon: 'reset'
    },
    {
        key: 'matparam',
        type: ComposerOptionActionsType.SET_MATERIAL_PARAMETER,
        name: T._('Change a material setting', 'Admin'),
        description: T._('One parameter of a material — roughness, opacity, metalness', 'Admin'),
        valueLabel: T._('Parameter', 'Admin'),
        icon: 'setting'
    },
    {
        key: 'printing',
        type: ComposerOptionActionsType.SET_PRINTING_METHOD,
        name: T._('Change the printing method', 'Admin'),
        description: T._('How the decoration is produced', 'Admin'),
        valueLabel: T._('Method', 'Admin'),
        icon: 'print'
    },
    {
        key: 'trigshow',
        type: 'SHOW_HOTSPOT',
        name: T._('Show a hotspot', 'Admin'),
        description: T._('Make a hotspot appear on the product', 'Admin'),
        valueLabel: T._('Hotspot', 'Admin'),
        icon: 'hotspot',
        disabled: true
    },
    {
        key: 'trighide',
        type: 'HIDE_HOTSPOT',
        name: T._('Hide a hotspot', 'Admin'),
        description: T._('Take a hotspot off the product', 'Admin'),
        valueLabel: T._('Hotspot', 'Admin'),
        icon: 'hotspot',
        disabled: true
    }
];

export const getComposerActionDefinition = (type: ComposerOptionActionsType): ComposerActionDefinition =>
    getComposerActionCatalog().find((definition) => definition.type === type) ?? getComposerActionCatalog()[0];
